<template>
  <div id="index" @keydown="keydown()">
    <el-container>
      <el-main class="clientLoginMain">
        <el-row :gutter="24" style="margin: 0px !important">
          <el-col :xs="0" :sm="0" :md="12" :lg="12">
            <img
              v-if="brand == 'IR'"
              src="~assets/img/Loginlogo.png"
              class="loginIcon"
            />
            <img
              v-if="brand == 'GD'"
              src="~assets/img/GDlogo.png"
              class="loginIcon"
            />
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="login-box">
              <h3 class="login-title">
                <img v-if="brand == 'IR'" src="~assets/img/logoBox.png" />
                <img v-if="brand == 'GD'" src="~assets/img/logoBox_GD.png" />
                <br />
                {{ $t("title.title") }}
              </h3>
              <el-form
                ref="loginForm"
                :model="form"
                label-width="0px"
                class="login-input"
              >
                <el-form-item prop="username">
                  <el-input
                    type="text"
                    placeholder="Username"
                    v-model="form.userNameOrEmailAddress"
                  >
                    <img
                      slot="prefix"
                      src="~assets/img/btnIcon/profile_circled.png"
                    />
                  </el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                    type="password"
                    placeholder="Password"
                    v-model="form.password"
                    show-password
                  >
                    <img slot="prefix" src="~assets/img/btnIcon/lock.png" />
                  </el-input>
                </el-form-item>
                <el-button
                  type="primary"
                  class="lopginbtn"
                  @click="login"
                  style="margin-top: 16px"
                  >{{ $t("button.login") }}
                </el-button>
              </el-form>
              <div style="margin-top: 24px; margin-left: 10px">
                <div class="fl Language_div">
                  <a @click="changeLanguage('en')">English </a> |
                  <a @click="changeLanguage('zh')"> 中文简体</a>
                  <br />
                  <br />
                </div>
                <div class="fr Language_div">
                  <a @click="forgetPws()">{{ $t("title.forgetPwd") }} </a>
                </div>
                <div class="clear"></div>
              </div>
            </div>
          </el-col>
          <el-col :xs="3" :sm="6" :md="7" :lg="8">
            <div class="logincenter"></div>
          </el-col>
        </el-row>

        <div class="loginRecordBox">
          <el-link href="http://www.irconnectivity.com" target="_blank"
            >备案主体：英格索兰（中国）投资有限公司
          </el-link>
          <el-link href="http://www.beian.miit.gov.cn" target="_blank"
            >备案号：沪ICP备05062828号-5
          </el-link>
          <el-link
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502005741"
            target="_blank"
            ><img
              src="~assets/img/recordicon.png"
              style="float: left; width: 16px"
            />沪公网安备 31010502005741号
          </el-link>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script type="text/javascript">
import { mapMutations } from "vuex";
import { authenticate } from "../../api/api";
import { setCookie, getCookie } from "../../../utils/package-cookies";
import {
  setItemToLocalstorage,
  getItemFormLocalstorage,
} from "../../../utils/package-localstorage";
import defaultSettings from "@/config/defaultSettings";
export default {
  name: "Index",
  data() {
    return {
      // 对话框显示和隐藏
      dialogVisible: false,
      form: {
        userNameOrEmailAddress: "",
        password: "",
        clientName: this.$route.path,
      },
      brand: "",
    };
  },
  created: function () {
    var that = this;
    that.brand = Globals.VUE_APP_Brand;
  },
  methods: {
    ...mapMutations(["setLanguage"]),
    changeLanguage(e) {
      window.localStorage.setItem("user_lang", e);
      this.setLanguage(e);
      window.location.reload();
    },
    keydown(e) {
      var theEvent = e || window.event;
      var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
      if (code == 13) {
        this.login();
      }
    },
    login() {
      var that = this;
      that.form.userNameOrEmailAddress =
        that.form.userNameOrEmailAddress.trim();
      that.form.password = that.form.password.trim();
      console.log(that.form);
      if (that.form.userNameOrEmailAddress == "" || that.form.password == "") {
        that.$message({
          showClose: true,
          message: that.$t("tips.validate"),
          type: "error",
        });
        return;
      }
      // const jse = new this.$jsEncrypt(); // 实例化一个 jsEncrypt 对象
      // jse.setPublicKey(Globals.RSAWebPublicKey); //配置公钥
      // var req = JSON.parse(JSON.stringify(that.form));
      // var rsaEnCrypt = jse.encrypt(req.password); //加密密码
      // req.password = rsaEnCrypt;
      authenticate(this.form)
      //authenticate(req)
        .then((res) => {
          if (res.success) {
            setItemToLocalstorage("userName", res.result.userName);
            setCookie("userName", res.result.userName, 1);
            setCookie("userSessionID", res.result.sessionId, 1); //存储sessionID
            setItemToLocalstorage("userInfo", res.result.userId); //存储用户信息
            setItemToLocalstorage("auth", res.result.accessToken);
            sessionStorage.setItem("customerType", res.result.customerType);
            localStorage.setItem("isneedchange", res.result.isNeedChangePass);
            if(res.result.accountType == "emcCustomer") {
              localStorage.setItem("emcStationProject", res.result.emcStationProject);
              const targetUrl = `/OneStationMonitor?id=${res.result.emcStationProject}`
              // &name=${row.projectName}&nameEn=${row.projectNameEn}&img=${row.stationImgUrl};
              window.location.href = targetUrl;
            }
            if (
              res.result.verifyId != undefined &&
              res.result.verifyId != null &&
              res.result.verifyId != ""
            ) {
              setCookie("vid", res.result.verifyId, 1);
            }
            that.$router.push("/client/default");
          }
        })
        .catch((err) => {
          this.$message.error(err.error.message);
        });
    },
    forgetPws() {
      this.$router.push("/ResetPassword");
    },
  },
};
</script>
<style lang='less' scope>
.el-button--primary:focus,
.el-button--primary:hover {
  background: #d52b1e;
  border-color: #603a3a;
  color: #fff;
}

.clientLoginMain {
  position: fixed !important;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("~assets/img/login.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0 !important;
  width: 100%;
}

.el-main {
  padding: 20px 7%;
}

.login-box .el-input__inner {
  height: 48px;
  background: #f7f7f8;
  border-radius: 30px;
  border: 1px solid #cbcdd3;
  font-size: 14px;
  color: #1f2128;
}
.login-box {
  el-form .el-form-item {
    margin-top: 16px;
  }
  .el-input__icon {
    font-size: 20px;
    color: #5e6166;
  }
  .el-input__prefix {
    left: 10px;
    top: 2px;
  }
  .el-input__suffix {
    top: 2px;
    right: 10px;
  }
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus,
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus {
  border-color: #603a3a !important;
}
.loginRecordBox {
  margin-left: 0 !important;
}
@media (min-width: 992px) {
  .el-col-sm-0 {
    display: block;
  }
  .el-col-xs-0 {
    display: block;
  }
}
</style>
